import React from 'react';
import PropTypes from 'prop-types';
import Layout from '../components/LayoutHome';
import Download from '../views/Home/Download/Download';

const IndexPage = props => {
  const {
    pageContext: { locale },
    location: { pathname },
  } = props;

  return (
    <Layout locale={locale} localeDir={pathname}>
      <Download locale={locale} />
    </Layout>
  );
};

IndexPage.propTypes = {
  pageContext: PropTypes.shape({
    locale: PropTypes.string,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
};

export default IndexPage;
